// 俄文
export default {
    dialog: {
        msgShow: "Уведомление",
        buttonOk: 'Да',
        buttonCancel: 'Отмена',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Закрыть'
    },
    employeeNumber: 'ID техника',
    pleaseEnterEmployeeNumber: 'Введите ID',
    password: 'Пароль',
    pleaseEnterPassword: 'Введите пароль',
    login: 'Входить',
    required: 'Необходимо',
    synchronize: 'Синхрон',
    salesOrder: null,
    pleaseEnterHome: 'Введите название клиента и отчет',
    searchFilter: 'Поиск и филтр',
    machineSpecifications: 'Модель и спецификация',
    processingStatus: 'Поиск и просмотр',
    processing: 'В работе',
    finish: null,
    waitCountermeasures: null,
    reset: 'Назад',
    submit: 'Отправлено',
    muMachineInvestigation: 'Производительность',
    logout: 'Выйти',
    searchDate: 'Дата поиска',
    time: 'Время поиска',
    basicInformation: 'Данные о клиентах',
    addSalesOrder: null,
    save: 'Сохранять',
    date: 'Дата',
    pleaseSelectDate: 'Выберите дату',
    travelNumber: 'Файл отчета об обслуживании',
    pleaseEnterTravelNumber: 'Введите номер отчета',
    customerCode: 'Код клиента',
    pleaseEnterCustomerCode: 'Введите код клиента',
    customerName: 'Название клиента',
    pleaseEnterCustomerName: 'Введите название клиента',
    country: 'Страна',
    pleaseEnterCountry: 'Введите страну',
    customerAddress: 'Адрес клиента',
    pleaseEnterAddress: 'Введите адрес клиента',
    customerContact: 'Уполномоченное лицо клиента',
    pleaseEnterContact: 'Введите данные упол-го лица',
    salesRepresentative: 'Представитель по продажам',
    pleaseEnterSalesRepresentative: 'Введите данные представителя',
    hint: 'Уведомление',
    createDate: 'Дата создания',
    salesOrderNumber: 'Номер отчета об обслуживании',
    customerSatisfaction: 'Удовлетворенность клиентов',
    maintenancePersonnel: 'технический персонал',
    maintenanceTime: 'Время обслуживания',
    customerConfirmation: 'Подтверждение клиента',
    copy: 'Копирование',
    delete: 'Выключать',
    recordTime: null,
    machineNumber: 'Серийный номер машины',
    copyToSalesOrder: 'Добавить в сервисный файл',
    copyTo: 'Копировать в',
    selectSalesOrderNumber: 'Выберите номер заказа услуги',
    pleaseEnterSalesOrderNumber: null,
    latitudeAndLongitude: 'Широта и долгота',
    startMaintenance: 'выбор услуги',
    endMaintenance: null,
    newMachine: 'Отчет об установке',
    maintenance: 'Ремонт машин',
    addMachineServiceOrder: null,
    selectType: 'Выберите тип',
    generalMaintenance: 'Обзор',
    oilEducationTraining: 'Обучение "OIL"',
    pleaseEnterMachineNumber: 'Введите номер оборудования',
    manufacturingDate: 'Дата производства',
    pleaseSelectManufacturingDate: 'Выберите дату производства',
    maintenanceWarranty: 'Гарантийный срок (1 год)',
    underWarranty: 'Гарантийное обслуживание',
    warrantyExpired: 'Негарантийное обслуживание',
    confirm: 'ОК',
    cancel: 'Отмена',
    addMaintenancePersonnel: 'Введите имя для доп. техника',
    maintenanceTimeTotal: null,
    day: 'День',
    hour: 'Час',
    enterFactory: null,
    pleaseSelectEnterFactory: 'Пожалуйста, запустите службу',
    longitude: 'Долгота',
    // pleaseEnterLongitude: 'Введите широту',
    latitude: 'Широта',
    // pleaseEnterLatitude: 'Введите долготу',
    leaveFactory: null,
    pleaseSelectLeaveFactory: 'Пожалуйста, завершите обслуживание',
    duration: null,
    pleaseEnter: 'Пожалуйста введите',
    selectTime: 'Выберите дату и время',
    selectSatisfaction: 'Удовлетворенность клиента',
    verySatisfied: 'Очень доволен',
    satisfied: 'Доволен',
    ordinary: null,
    dissatisfied: 'Не доволен',
    veryDissatisfied: 'Совсем не рад',
    opinionReply: 'Комментарий клиента',
    takePhoto: null,
    uploadFile: null,
    audio: 'Звуковой файл',
    video: 'Видео файл',
    electronicSignature: 'Подпись клиента',
    signatureDate: 'Дата подписания',
    clear: 'Удалить',
    machineInformation: 'Данные об оборудовании',
    machineFunction: null,
    organizationArrangement: 'Структура замка и шаблон',
    spareParts: 'Запчасти',
    operationProcedure: null,
    problemHandling: 'Определения проблем',
    trainee: 'Обученный',
    coursePlan: 'План обучения',
    courseSchedule: 'Расписание обучения',
    inputVoltageAndCurrent: 'Введите напряжение и ток',
    lowSpeed: 'Низкая скорость',
    highSpeed: 'Высокая скорость',
    accelerationDecelerationSlope: 'Ускорение/Замедление',
    acceleration: 'Ускорение',
    deceleration: 'Замедление',
    clothRoller: 'Настройка роликовой системы',
    left: 'Лева',
    center: 'Середина',
    right: 'Права',
    yarnFeedingTeeth: 'Шкив',
    saddleRingDistance: 'Воздушный зазор',
    yarnNozzleNumber: 'Необработанное полотно',
    height: 'Высота игл крышки',
    spacing: 'Зазор игл цилиндра',
    warpYarnInfo: 'Необ. полотно',
    inch: 'Дюймы',
    cm: 'см(сантиметр)',
    timeSequence: 'Тайминг',
    needle: 'Иглы',
    yarnSpecification: 'Спецификация пряжи',
    yarn: 'Пряжа',
    serialNumber: 'Номера других машин',
    technician: 'Техник',
    series: 'Номер партии полотна',
    fabricType: 'Тип полотна',
    productFeatures: 'Особенности продукта',
    inputVoltage: 'Введите напряжение',
    inputCurrent: 'Введите ток',
    electronicWindingTensionUpper: 'Elec. roller ampere ( upper)',
    electronicWindingTensionLower: 'Elec. roller ampere (lower)',
    mechanicalType: 'Мех. ролик передача',
    lowerNeedleDistanceToSeatRing: 'Dis. cylinder & cam holder ring',
    upperNeedleDistanceToSeatRing: 'Dis. dial & cam holder ring',
    upperNeedleDistanceToLowerNeedleNozzle: 'Gap dial & cylinder knock over edge',
    selectorNeedleRingDistanceToTakeUpPlate: 'Dis. between actuator ring & frame',
    seatRingDistanceToTakeUpPlate: 'Dis. between cam holder ring & frame',
    machineSpeed: 'RPM',
    inverterFrequency: 'Hz',
    yarnCount: 'Крупность (на дюйм)',
    gramsPerSquareMeter: 'gr/m2',
    yardsPerPound: 'gr/yd',
    customerYarnWidth: 'Ширина',
    customerSpecifiedYarnLength: 'Длина нитки',
    newCustomerPackageTiming: 'Платиновой тайминг',
    doubleSidedCuttingTiming: 'Тайминг замка крышки',
    nozzleTiming: 'Время носителя нити',
    yarnCode: 'Код пряжи',
    yarnType: 'Спецификация пряжи',
    color: 'Цвет пряжи',
    yarnSize: 'Номер пряжи',
    fiberCount: 'Количество волокон',
    innerFiber: 'Внутренний ворс',
    outerFiber: 'Внешний ворс',
    flatness: 'Плоскостность',
    roundness: 'Округлость',
    windPressure: 'Давление воздуха',
    appearance: 'Появление',
    machineLevel: 'Уравновешенность рамы',
    trident: 'Уравновешенность крышки',
    highLegWinder: 'Роликовая система высокой ножки',
    fabricSlitting: 'Роликовая система открытой ширины',
    inverterCurrent: 'Ток инвертера',
    machineFunctionFrame: 'Фидер, Кольцо, Штакетники',
    inchStart: 'Ф-я перек. запуска и остановки',
    firstSecondSpeed: 'Ф-я перек. скорости, лампы и вент.',
    firstSecondSpeed2: 'Функция настройки скорости',
    controllerOtherFunctions: 'Другие функции панели управления',
    electricalBoxSignals: 'Сигнал и датчик',
    fanDustRemovalAction: 'Операция вентилятора',
    oilSprayerAction: 'Операция смазывания',
    airBlowerSystemAction: 'Давление воздуха и операция',
    windingAction: 'Роликовая система и операция',
    machineControllerOperationTutorial: 'Обучение работе панели управления',
    machineOperationTutorial: 'Обучение работе с оборудованием',
    other: 'Другие',
    descriptionAndAttachment: null,
    upperNeedleArrangement: null,
    upperKnifeArrangement: null,
    lowerNeedleArrangement: null,
    lowerNeedleArrangementShort: null,
    lowerKnifeArrangement: null,
    lowerKnifeArrangementShort: null,
    upperNeedlePlate: 'Цилиндр крышки',
    lowerNeedleCylinder: 'Цилиндр',
    blank: 'Зазор',
    blockRule: 'Фиксирующий калибр',
    retractionBaseline: 'Расстояние между валиком и иглой',
    upperPlateNeedleWithdrawalKnob: 'Шкала крышки',
    upperPlateNeedleWithdrawalDepth: 'Dial stitch dist.',
    upperPlateHalfNeedleHeight: 'Dial knit, tuck cam dist.',
    upperPlateFlatNeedleHeight: 'Dial miss cam dist.',
    lowerCylinderFlatNeedleHeight: 'Cylinder miss cam dist.',
    lowerCylinderFlatNeedleDepth: 'Cylinder stitch dist.',
    lowerCylinderNeedleWithdrawalKnob: 'Шкала цилиндра',
    yarnTypeCode: 'Код пряжи',
    yarnTypeTensionN: 'Натяжение пряжи (Н)',
    cmPer100Needles: 'Длина нити (в 100 иглах)',
    feedYarnLengthPerRevolution: 'Длина нити (за 1 стежок)',
    aluminumPlateYarnFeedingDepthCm: 'Диаметр шкива (см)',
    yarnFeedingAluminumPlateScale: 'Размер шкива',
    newCustomerPackage: 'Платина',
    upperPlate: 'Крышка',
    lowerCylinder: 'Цилиндр',
    yarnShort: 'Пряжа',
    pleaseEnterProductName: null,
    pleaseEnterProductNumber: null,
    quantity: 'Шт',
    damage: 'Сломанный',
    missing: null,
    wrong: null,
    pleaseEnterTitle: 'Введите название',
    pleaseEnterContent: 'Введите контент',
    addQuestionItem: 'Добавить вопрос',
    questionProcessingRecord: 'Запись сервисного решения',
    pleaseEnterQuestionDescription: 'Оставить комментарий о проблеме',
    traineeAndClient: 'Обученный',
    trainer: 'Инструктор',
    drawingFunction: 'CAD чертеж',
    upperMachineProgram: null,
    UnravelingFunction: 'Анализ ткани',
    courseName: 'Название образования',
    pleaseEnterCourseName: 'Введите название исследования',
    imageName: 'Название узора',
    pleaseEnterImageName: 'Введите название шаблона',
    confirmItem: 'Подтверждение',
    undone: 'Не завершен',
    pleaseEnterInquire: 'Введите наз. клиента, номер MU',
    machineUtilizationSurvey: 'Уровень использования оборудования',
    customerID: 'ID клиента',
    pleaseEnterCustomerID: 'Введите ID клиента',
    pleaseSelect: 'Выберите',
    pleaseEnterSkill: 'Пожалуйста, введите способность',
    pleaseEnterBuyer: 'Пожалуйста, введите получателя',
    pleaseEnterRemark: 'Пожалуйста, введите комментарий',
    source: 'Источник',
    selfInput: '自行輸入',
    textileEquipment: null,
    textileMachineBrand: null,
    textileMachineType: null,
    notSelected: 'Не выбрано',
    select: 'Выбрано',
    brand: 'Бренд',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Пожалуйста, введите содержимое конфигурации',
    // alert
    editNotSave: 'Вы уверены, что хотите выйти без сохранения изменений?',
    deleteConfirm: 'Вы уверены, что хотите удалить?',
    confirmClearSignature: 'Вы хотите удалить информацию о подписи?',
    confirmWriteData: 'Подтвердить запись данных?',
    confirmCopyToSalesOrder: 'Вы уверены, что хотите скопировать данные в этот отчет?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'Удаление успешно.',
    clearSuccess: 'Удаление успешно.',
    copySuccess: 'Копирование успешно.',
    selectWorker: 'Пожалуйста, выберите специалиста.',
    selectProblem: 'Пожалуйста, выберите пункт вопроса.',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Выберите дату',
    yarnTensionN: 'Натяжение пряжи (Н)',
    category: 'Тип',
    kind: 'Модель',
    // pleaseSelectType: 'Выберите тип',
    dateInOutError: 'Дата окончания сервиса всегда должна быть равна или позже даты начала обслуживания.',
    yarnFeedingTeethOrDisc: 'Шкив',
    changed: 'Измененный',
    pleaseSelectSparePartsStatus: 'Пожалуйста, выберите состояние аксессуаров.',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: 'Успешно сохранено',
    needOnline: 'Need Online.',
    addComplete: 'Успешно добавлено',
    reportCreator: 'Создатель отчетов',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'Синхронизация прошла успешно.',
    downloadFail: '下載異常',
    downloadSuccess: 'Загрузка прошла успешно.',
    synchronizeSelect: 'Синхронизировать выбор',
    onlySynchronizeOffData: 'Загрузка онлайн-данных',
    synchronizeData: null,
    synchronizeImage: 'Синхронизировать изображение',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Загрузить офлайн-данные.',
    downloadOfflineImage: 'Загрузить офлайн изображение',
    synchronizing: 'Синхронизация, пожалуйста, подождите. Не закрывайте экран приложения.',
    downloading: 'Загрузка, пожалуйста, подождите. Не закрывайте экран приложения.',
    confirmDownload: '«Вы подтверждаете загрузку?',
    confirmSynchronization: '«Вы подтверждаете синхронизацию?',
    overwriteOffline : 'Загрузка перезапишет текущие офлайн-данные».',
    synchronizationOnline: 'Синхронизация приведет к синхронизации данных, связанных с онлайном».',
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Упорядочить по порядку создания',
    sortByType: 'Упорядочить по типу',
    reportDownload: 'отчет',
    selectServiceReport: 'Выберите отчет об услуге',
    enterServiceReportOrMachine: null,
    selectAll: 'Выбрать все',

    downloadHint:null
}
